/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeviceTypeSettingsRequest
 */
export interface DeviceTypeSettingsRequest {
    /**
     * 
     * @type {string}
     * @memberof DeviceTypeSettingsRequest
     */
    deviceTypeId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceTypeSettingsRequest
     */
    fwExtraName1?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceTypeSettingsRequest
     */
    fwExtraName2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceTypeSettingsRequest
     */
    fwExtraName3?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DeviceTypeSettingsRequest
     */
    loaderMaxRetries?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DeviceTypeSettingsRequest
     */
    fwMaxRetries?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DeviceTypeSettingsRequest
     */
    uiMaxRetries?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceTypeSettingsRequest
     */
    eda?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceTypeSettingsRequest
     */
    urlPreProd?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceTypeSettingsRequest
     */
    allowDowngradeUr?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceTypeSettingsRequest
     */
    allowUidUpdate?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceTypeSettingsRequest
     */
    disableCheckSn?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceTypeSettingsRequest
     */
    urSendAllAtOnce?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceTypeSettingsRequest
     */
    disableTagUrl?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceTypeSettingsRequest
     */
    enableDeploymentMode?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceTypeSettingsRequest
     */
    addBPProfile?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceTypeSettingsRequest
     */
    enableQuota?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceTypeSettingsRequest
     */
    enableStbAuth?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceTypeSettingsRequest
     */
    loaderBypass?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceTypeSettingsRequest
     */
    enablelightReset?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceTypeSettingsRequest
     */
    enablefullReset?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceTypeSettingsRequest
     */
    enablereboot?: boolean | null;
}

export function DeviceTypeSettingsRequestFromJSON(json: any): DeviceTypeSettingsRequest {
    return DeviceTypeSettingsRequestFromJSONTyped(json, false);
}

export function DeviceTypeSettingsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeviceTypeSettingsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'deviceTypeId': !exists(json, 'deviceTypeId') ? undefined : json['deviceTypeId'],
        'fwExtraName1': !exists(json, 'fwExtraName1') ? undefined : json['fwExtraName1'],
        'fwExtraName2': !exists(json, 'fwExtraName2') ? undefined : json['fwExtraName2'],
        'fwExtraName3': !exists(json, 'fwExtraName3') ? undefined : json['fwExtraName3'],
        'loaderMaxRetries': !exists(json, 'loaderMaxRetries') ? undefined : json['loaderMaxRetries'],
        'fwMaxRetries': !exists(json, 'fwMaxRetries') ? undefined : json['fwMaxRetries'],
        'uiMaxRetries': !exists(json, 'uiMaxRetries') ? undefined : json['uiMaxRetries'],
        'eda': !exists(json, 'eda') ? undefined : json['eda'],
        'urlPreProd': !exists(json, 'urlPreProd') ? undefined : json['urlPreProd'],
        'allowDowngradeUr': !exists(json, 'allowDowngradeUr') ? undefined : json['allowDowngradeUr'],
        'allowUidUpdate': !exists(json, 'allowUidUpdate') ? undefined : json['allowUidUpdate'],
        'disableCheckSn': !exists(json, 'disableCheckSn') ? undefined : json['disableCheckSn'],
        'urSendAllAtOnce': !exists(json, 'urSendAllAtOnce') ? undefined : json['urSendAllAtOnce'],
        'disableTagUrl': !exists(json, 'disableTagUrl') ? undefined : json['disableTagUrl'],
        'enableDeploymentMode': !exists(json, 'enableDeploymentMode') ? undefined : json['enableDeploymentMode'],
        'addBPProfile': !exists(json, 'addBPProfile') ? undefined : json['addBPProfile'],
        'enableQuota': !exists(json, 'enableQuota') ? undefined : json['enableQuota'],
        'enableStbAuth': !exists(json, 'enableStbAuth') ? undefined : json['enableStbAuth'],
        'loaderBypass': !exists(json, 'loaderBypass') ? undefined : json['loaderBypass'],
        'enablelightReset': !exists(json, 'enablelightReset') ? undefined : json['enablelightReset'],
        'enablefullReset': !exists(json, 'enablefullReset') ? undefined : json['enablefullReset'],
        'enablereboot': !exists(json, 'enablereboot') ? undefined : json['enablereboot'],
    };
}

export function DeviceTypeSettingsRequestToJSON(value?: DeviceTypeSettingsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'deviceTypeId': value.deviceTypeId,
        'fwExtraName1': value.fwExtraName1,
        'fwExtraName2': value.fwExtraName2,
        'fwExtraName3': value.fwExtraName3,
        'loaderMaxRetries': value.loaderMaxRetries,
        'fwMaxRetries': value.fwMaxRetries,
        'uiMaxRetries': value.uiMaxRetries,
        'eda': value.eda,
        'urlPreProd': value.urlPreProd,
        'allowDowngradeUr': value.allowDowngradeUr,
        'allowUidUpdate': value.allowUidUpdate,
        'disableCheckSn': value.disableCheckSn,
        'urSendAllAtOnce': value.urSendAllAtOnce,
        'disableTagUrl': value.disableTagUrl,
        'enableDeploymentMode': value.enableDeploymentMode,
        'addBPProfile': value.addBPProfile,
        'enableQuota': value.enableQuota,
        'enableStbAuth': value.enableStbAuth,
        'loaderBypass': value.loaderBypass,
        'enablelightReset': value.enablelightReset,
        'enablefullReset': value.enablefullReset,
        'enablereboot': value.enablereboot,
    };
}

